export default __webpack_public_path__ + "static/media/beep.c4d01acc.wav";